import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { getEnv, getUuid, isAndroid, isIos, queryParse } from "../utils";
import Base64 from "./Base64";
import { getSystemInfo } from "./getSystemInfo";
import { storage } from "./storage";
var _objToStr = function _objToStr(obj) {
  var spliter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '^';
  if (!obj) return '';
  var strArr = [];
  var prop;
  if (obj instanceof Array) {
    strArr = obj;
  } else if (obj instanceof Object) {
    for (prop in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        strArr.push("".concat(prop, "=").concat(obj[prop]));
      }
    }
  }
  return strArr.join(spliter).replace(/,/g, '%2C');
};
var setDeviceUUid = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var key, uuid;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          key = 'deivceTag';
          _context.next = 3;
          return storage.getStorage(key, '');
        case 3:
          uuid = _context.sent;
          if (uuid) {
            _context.next = 8;
            break;
          }
          uuid = "device_".concat(getUuid());
          _context.next = 8;
          return storage.setStorage(key, uuid);
        case 8:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function setDeviceUUid() {
    return _ref.apply(this, arguments);
  };
}();
var _getContainerType = function _getContainerType() {
  return isAndroid || isIos ? 'H5' : 'PC';
};
var _getPageId = function _getPageId() {
  var _window, _window$autoReportCon, _window2, _window2$autoReportCo;
  return (_window = window) !== null && _window !== void 0 && (_window$autoReportCon = _window.autoReportConfig) !== null && _window$autoReportCon !== void 0 && _window$autoReportCon.spmId ? "".concat((_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$autoReportCo = _window2.autoReportConfig) === null || _window2$autoReportCo === void 0 ? void 0 : _window2$autoReportCo.spmId, "_").concat(Base64.fromNumber(+new Date())) : "".concat(Base64.fromNumber(+new Date()));
};
var formatReportData = function formatReportData(options) {
  return new Promise(function (resolve) {
    var _window3, _window3$autoReportCo;
    var logType = options.logType,
      userId = options.userId,
      programVersion = options.programVersion,
      _options$logLevel = options.logLevel,
      logLevel = _options$logLevel === void 0 ? 2 : _options$logLevel,
      bizType = options.bizType,
      sessionId = options.sessionId,
      productId = options.productId,
      appId = options.appId,
      param4 = options.param4,
      version = options.version;
    var dt = new Date();
    var fillDate = function fillDate(num) {
      return num < 10 ? "0".concat(num) : "".concat(num);
    };
    setDeviceUUid();
    var promiseArroy = [getSystemInfo(), ((_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$autoReportCo = _window3.autoReportConfig) === null || _window3$autoReportCo === void 0 ? void 0 : _window3$autoReportCo.env) || getEnv()];
    Promise.all(promiseArroy).then(function (allData) {
      var _systemInfo$platform, _window4, _window4$autoReportCo, _systemInfo$platform2, _systemInfo$system, _window5, _window5$autoReportCo, _systemInfo$model, _systemInfo$language, _systemInfo$brand;
      var systemInfo = allData[0];
      var env = allData[1];
      // 从参数获取渠道来源
      var chinfo = '';
      if (typeof window !== 'undefined') {
        var queryRes = queryParse();
        chinfo = (queryRes === null || queryRes === void 0 ? void 0 : queryRes.chInfo) || '';
      }
      var mdata = {
        // 通用的数据，可不传，传了所有的埋点均会带该额外参数
        idengine_groupId: appId,
        // 应用id作为扩展参数上报
        idengine_chinfo: chinfo || '',
        idengine_version: version || '',
        source: '',
        chinfo: chinfo || ''
      };
      var arr = ['D-AE', // 1. 日志头
      "".concat(dt.getFullYear(), "-").concat(fillDate(dt.getMonth() + 1), "-").concat(fillDate(dt.getDate()), " ").concat(fillDate(dt.getHours()), ":").concat(fillDate(dt.getMinutes()), ":").concat(fillDate(dt.getSeconds()), ":").concat(dt.getMilliseconds()),
      // 2. 客户端日志时间
      "".concat(productId || appId, "_").concat((systemInfo === null || systemInfo === void 0 ? void 0 : (_systemInfo$platform = systemInfo.platform) === null || _systemInfo$platform === void 0 ? void 0 : _systemInfo$platform.toUpperCase()) || '', "-").concat(env.toUpperCase()) || '-',
      // 3. 客户端ID
      (systemInfo === null || systemInfo === void 0 ? void 0 : systemInfo.version) || '-',
      // 4. 客户端版本
      productId ? '4' : '3' || '-',
      // 5. 日志版本
      ((_window4 = window) === null || _window4 === void 0 ? void 0 : (_window4$autoReportCo = _window4.autoReportConfig) === null || _window4$autoReportCo === void 0 ? void 0 : _window4$autoReportCo.deviceId) || '-',
      // 6. 终端ID
      sessionId || getUuid() || '-',
      // 7. 会话ID
      (userId === null || userId === void 0 ? void 0 : userId.replace(/,/g, '%2C')) || '-',
      // 8. 用户ID
      1000, // 9. 采样率
      "web_".concat(logType),
      // 10. 事件ID
      bizType || '-',
      // 11. bizType
      logLevel || '-',
      // 12. logLevel默认值
      _getPageId() || '-',
      // 13. pageId
      '-',
      // 14. abtestId
      '-',
      // 15. ucid用例编号
      '-',
      // 16. 补丁版本
      (systemInfo === null || systemInfo === void 0 ? void 0 : (_systemInfo$platform2 = systemInfo.platform) === null || _systemInfo$platform2 === void 0 ? void 0 : _systemInfo$platform2.replace(/,/g, '%2C')) || '-',
      // 17. 操作系统类别
      (systemInfo === null || systemInfo === void 0 ? void 0 : (_systemInfo$system = systemInfo.system) === null || _systemInfo$system === void 0 ? void 0 : _systemInfo$system.replace(/,/g, '%2C')) || '-',
      // 18. 操作系统版本 淘宝 iphone下会带,  【iphone11,6】
      ((_window5 = window) === null || _window5 === void 0 ? void 0 : (_window5$autoReportCo = _window5.autoReportConfig) === null || _window5$autoReportCo === void 0 ? void 0 : _window5$autoReportCo.networkType) || '-',
      // 19. 网络类型
      (systemInfo === null || systemInfo === void 0 ? void 0 : (_systemInfo$model = systemInfo.model) === null || _systemInfo$model === void 0 ? void 0 : _systemInfo$model.replace(/,/g, '%2C')) || '-',
      // 20. 手机型号
      programVersion || '-',
      // 21. 内部版本号
      '-',
      // 22. 渠道号
      '-',
      // 23. UTDID
      (systemInfo === null || systemInfo === void 0 ? void 0 : (_systemInfo$language = systemInfo.language) === null || _systemInfo$language === void 0 ? void 0 : _systemInfo$language.replace(/,/g, '%2C')) || '-',
      // 24. 语言
      '-',
      // 25. 制造商
      "".concat(systemInfo === null || systemInfo === void 0 ? void 0 : systemInfo.screenWidth, "x").concat(systemInfo === null || systemInfo === void 0 ? void 0 : systemInfo.screenHeight) || '-',
      // 26. 分辨率
      appId || '-',
      // 27. appId
      '-',
      // 28. 进程名
      (systemInfo === null || systemInfo === void 0 ? void 0 : (_systemInfo$brand = systemInfo.brand) === null || _systemInfo$brand === void 0 ? void 0 : _systemInfo$brand.replace(/,/g, '%2C')) || '-',
      // 29. 手机属性
      '-',
      // 30. 客户端预留信息
      '-',
      // 31. 用户信息预留
      getUuid() || '-',
      // 32. 序列id
      '-',
      // 33. 业务额外参数，两平台保持一致
      '-',
      // 34. 扩展1
      '-',
      // 35. 扩展2
      '-',
      // 36. 扩展3
      _objToStr(Object.assign({}, mdata, {
        containerType: _getContainerType(),
        logVersion: 1,
        reporterJsVersion: "@alipay/intl-tracker-0.0.9001657688-dev.1"
      }, param4)),
      // 37. 扩展4
      '-',
      // 38 扩展字段5
      '-' // 39 预留字段2
      ];

      var formatData = arr.map(function (item) {
        return new String(item).replace(/,/gi, '_').toString();
      });
      resolve(formatData);
    });
  });
};
export default formatReportData;